module.exports = __webpack_public_path__ + "static/media/hp-home-banner-tablet-@1x.e5dcc990.jpg";